import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import FirstKv from './components/FirstKv';
import css from './index.module.scss';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import Annotation from '@/components/Annotation';

const PageConPc = dynamic(() => import('@/components/productSmart/glacier/detail/indexDynamic'), {
    ssr: true,
});
export default function GlacierH5() {
    const { gloproductlist } = useGlobal();
    const { locale = 'us' } = useRouter();
    const product: any = {
        cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_sp_220w_bi_solar_panel'],
        jp: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        mx: ['product_ps_river_703', 'product_ps_river_river_768', 'product_ps_river_river_512'],
    };
    const otherProductData = getDetaileMoreProducts(
        gloproductlist,
        product[locale as keyof typeof product] || product.cn,
        '',
        '',
        `https://${locale}.ecoflow.com/collections/portable-power-stations`,
    );

    if (['jp', 'cn'].includes(locale as string) && otherProductData.items && otherProductData.items.length) {
        otherProductData.moreUrl = `https://${locale}.ecoflow.com/collections/portable-power-stations`;

        const text = (otherProductData.items[0] as any).titleText || '';
        Object.assign(otherProductData.items[0], {
            linkUrl: '/river-2-portable-power-station',
            titleText: locale === 'jp' ? 'RIVER 2 Pro リバー 2 Pro' : text,
        });
    }

    return (
        <div className={`glacier-h5 ${css.glacierH5}`}>
            <FirstKv />
            <PageConPc otherProductData={otherProductData} />
            <Annotation borderTopColor="transparent" bgColor="#000" boxStyle={{ width: '1120px' }} product={'GLACIER'} />
        </div>
    );
}
